import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-single",
  "use": "icon-arrow-single-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-single\"><path d=\"M512 992.01024l480.01024-480.01024-288.01024 0 0-512-384 0 0 512-288.01024 0z\" fill=\"#1890ff\" p-id=\"5104\" data-spm-anchor-id=\"a313x.search_index.0.i3.70943a81pas4k4\" class=\"selected\" stroke=\"black\" stroke-width=\"20px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol